import React from "react";
import PropTypes from "prop-types";
import "../../../NonRKPayInvoiceDetail.scss";
import { getDropdownActions } from "./NonRKPayInvoiceActionsConfig";
import ActionButton from "./ActionButton";
import ActionsList from "./ActionsList";

const NonRKPayToolbarActionsDropdown = ({
  nonRKPayInvoiceDetailHook,
  isSuperAdmin,
  handleSend,
  sendingInvoice,
}) => {
  const { lang } = global;
  const {
	savingInvoice,
	downloadingInvoice,
    invoiceState : { invoiceId },
  } = nonRKPayInvoiceDetailHook;

  const { toggleDropdown, actions } = getDropdownActions({
	nonRKPayInvoiceDetailHook,
    isSuperAdmin,
    lang,
    handleSend,
    sendingInvoice,
  });

  return (
    actions.some((action) => action.condition) && (
      <li className="dropdown" id="actions-menu">
        <button
          type="button"
          className="btn dropdown-toggle navbar-btn hidden-print"
          disabled={!invoiceId}
          title={invoiceId ? undefined : lang.t("ToolbarDisabledAction")}
          onClick={toggleDropdown}
          aria-haspopup="true"
          aria-expanded="false"
          data-test-id="nonrkpay-invoice-dropdown-actions"
        >
          <i className={`rkf rkf-spinner rkf-spin rkf-fw${downloadingInvoice || savingInvoice ? "" : " hidden"}`} />
          <span className={downloadingInvoice || savingInvoice ? "hidden" : "nonrkpay-actions-span"}>
            &nbsp;{lang.t("Actions")}&nbsp;
            <i id="nonrkpay-invoice-actions-chevron" className="rkf rkf-chevron-down" aria-label="actions chevron" />
          </span>
        </button>
        <ul className="dropdown-menu">
          <ActionsList actions={actions} ButtonComponent={ActionButton} />
        </ul>
      </li>
    )
  );
};

NonRKPayToolbarActionsDropdown.propTypes = {
  nonRKPayInvoiceDetailHook: PropTypes.object.isRequired,
  isSuperAdmin: PropTypes.bool,
  handleSend: PropTypes.func,
  sendingInvoice: PropTypes.bool,
};

NonRKPayToolbarActionsDropdown.defaultProps = {
	isSuperAdmin: false,
  handleSend: () => {},
  sendingInvoice: false,
};

export default NonRKPayToolbarActionsDropdown;
